"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeField = exports.CustomField = exports.UsernameField = exports.PasswordField = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Check = _interopRequireDefault(require("mdi-material-ui/Check"));

var _Close = _interopRequireDefault(require("mdi-material-ui/Close"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var UsernameAttributes = {
  EMAIL: "email",
  PHONE_NUMBER: "phone_number",
  USERNAME: "username"
};
var UsernameLabels = {
  "email": "Email",
  "phone_number": "Phone Number",
  "username": "Username"
};
var Validations = {
  "email": {
    // eslint-disable-next-line
    "Valid Email Address": /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    "Between 4 and 254 characters": /^.{4,254}$/
  },
  "username": {
    "No Sepecial Characters or spaces": /^[a-z0-9]+$/,
    "Between 4 and 254 characters": /^.{4,254}$/
  },
  "phone_number": {
    "Valid phone number": /^\+\d[\d ][\d ]\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  },
  "password": {
    'Between 8 and 25 characters': /^.{8,25}$/,
    'At least one number': /\d/,
    'At least one capital letter': /[A-Z]/,
    'At least one lowercase letter': /[a-z]/,
    'At least one special character (i.e. !$%^)': /[!@#$%^&*(),.?":{}|<>]/
  },
  "code": {
    "Exactly six digits": /^\d{6}$/
  }
};

var countCharacters = function countCharacters(characters) {
  return !characters ? 0 : characters.replace(/\D/g, "").length;
};

var TextMaskCustom = function TextMaskCustom(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, ["inputRef"]);

  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], _extends({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: function mask(rawValue) {
      return !countCharacters(rawValue) ? [] // ) : countCharacters(rawValue) <= 11 ? (
      //   ['+', /\d/, ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      // ) : countCharacters(rawValue) === 12 ? (
      //   ['+', /\d/, /\d/, ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      : // ['+', /\d/, /\d/, /\d/, ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    },
    placeholderChar: "\u2000",
    placeholder: "+1 (555) 555-5555",
    showMask: true,
    guide: true
  }));
};

var DateMaskCustom = function DateMaskCustom(props) {
  var inputRef = props.inputRef,
      other = _objectWithoutProperties(props, ["inputRef"]);

  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], _extends({}, other, {
    ref: function ref(_ref2) {
      inputRef(_ref2 ? _ref2.inputElement : null);
    },
    mask: function mask(rawValue) {
      return !!rawValue ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [];
    },
    placeholder: "MM/DD/YYYY",
    showMask: true,
    guide: true
  }));
};

var PhoneField = function PhoneField(_ref3) {
  var _customField$initialV;

  var customField = _ref3.customField,
      value = _ref3.value,
      onValueChange = _ref3.onValueChange,
      error = _ref3.error,
      isValid = _ref3.isValid;
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    disabled: !!customField.disabled,
    required: !!customField.required,
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    shrink: true
  }, customField.label), /*#__PURE__*/_react["default"].createElement(_core.OutlinedInput, {
    disabled: !!customField.disabled,
    value: !!value && !!value.replace(/^\+1/g, "").replace(/\D/g, "") ? /^\+1/.test(value) ? value : "+1".concat(value) : (_customField$initialV = customField.initialValue) !== null && _customField$initialV !== void 0 ? _customField$initialV : "",
    onChange: function onChange(_ref4) {
      var value = _ref4.target.value;
      return onValueChange(value.toLowerCase());
    },
    inputComponent: TextMaskCustom
  }), !!error && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], null, error));
};

var DateField = function DateField(_ref5) {
  var customField = _ref5.customField,
      value = _ref5.value,
      onValueChange = _ref5.onValueChange,
      error = _ref5.error,
      isValid = _ref5.isValid;
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    disabled: !!customField.disabled,
    required: !!customField.required,
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    variant: "outlined"
  }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
    shrink: true
  }, customField.label), /*#__PURE__*/_react["default"].createElement(_core.OutlinedInput, {
    disabled: !!customField.disabled,
    value: value || customField.initialValue || "",
    onChange: function onChange(_ref6) {
      var value = _ref6.target.value;
      return onValueChange(value.toLowerCase());
    },
    inputComponent: DateMaskCustom
  }), !!error && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], null, error));
};

var UsernameField = function UsernameField(_ref7) {
  var _ref7$disabled = _ref7.disabled,
      disabled = _ref7$disabled === void 0 ? false : _ref7$disabled,
      value = _ref7.value,
      usernameField = _ref7.usernameField,
      onValueChange = _ref7.onValueChange,
      onValidChange = _ref7.onValidChange,
      error = _ref7.error,
      _ref7$showValidators = _ref7.showValidators,
      showValidators = _ref7$showValidators === void 0 ? false : _ref7$showValidators;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValid = _useState2[0],
      setIsValid = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsValid(Object.entries(Validations[usernameField]).every(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          regex = _ref9[1];

      return regex.test(value);
    }));
  }, [usernameField, value]);
  (0, _react.useEffect)(function () {
    onValidChange(isValid);
  }, [isValid]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, usernameField === UsernameAttributes.PHONE_NUMBER ? /*#__PURE__*/_react["default"].createElement(PhoneField, {
    customField: {
      disabled: disabled,
      required: true,
      label: UsernameLabels[usernameField]
    },
    value: value,
    onValueChange: onValueChange,
    error: error,
    showValidators: showValidators,
    isValid: isValid,
    autoComplete: "new-password"
  }) : /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    disabled: disabled,
    required: true,
    type: usernameField === UsernameAttributes.EMAIL ? 'email' : 'text',
    onChange: function onChange(_ref10) {
      var value = _ref10.target.value;
      return onValueChange(value.toLowerCase());
    },
    label: UsernameLabels[usernameField],
    InputLabelProps: {
      shrink: true
    },
    value: value,
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    helperText: (error || "").replace(/User is disabled/, "Account has been disabled"),
    variant: "outlined"
  }), showValidators && /*#__PURE__*/_react["default"].createElement(_List["default"], {
    dense: true
  }, Object.entries(Validations[usernameField]).map(function (_ref11, i) {
    var _ref12 = _slicedToArray(_ref11, 2),
        key = _ref12[0],
        regex = _ref12[1];

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, regex.test(value) ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
      style: {
        color: 'green'
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      style: {
        color: 'red'
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: key
    }));
  })));
};

exports.UsernameField = UsernameField;

var PasswordField = function PasswordField(_ref13) {
  var _ref13$label = _ref13.label,
      label = _ref13$label === void 0 ? "Password" : _ref13$label,
      value = _ref13.value,
      onValueChange = _ref13.onValueChange,
      onValidChange = _ref13.onValidChange,
      error = _ref13.error,
      helperText = _ref13.helperText,
      _ref13$showValidators = _ref13.showValidators,
      showValidators = _ref13$showValidators === void 0 ? false : _ref13$showValidators;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isValid = _useState4[0],
      setIsValid = _useState4[1];

  (0, _react.useEffect)(function () {
    setIsValid(Object.entries(Validations.password).every(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
          key = _ref15[0],
          regex = _ref15[1];

      return regex.test(value);
    }));
  }, [value]);
  (0, _react.useEffect)(function () {
    onValidChange(isValid);
  }, [isValid]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    required: true,
    InputLabelProps: {
      shrink: true
    },
    type: 'password',
    onChange: function onChange(_ref16) {
      var value = _ref16.target.value;
      return onValueChange(value);
    },
    label: label,
    value: value,
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    helperText: error || helperText || "",
    variant: "outlined",
    autoComplete: "new-password"
  }), showValidators && /*#__PURE__*/_react["default"].createElement(_List["default"], {
    dense: true
  }, Object.entries(Validations.password).map(function (_ref17, i) {
    var _ref18 = _slicedToArray(_ref17, 2),
        key = _ref18[0],
        regex = _ref18[1];

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, regex.test(value) ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
      style: {
        color: 'green'
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      style: {
        color: 'red'
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: key
    }));
  })));
};

exports.PasswordField = PasswordField;

var CodeField = function CodeField(_ref19) {
  var value = _ref19.value,
      onValueChange = _ref19.onValueChange,
      onValidChange = _ref19.onValidChange,
      error = _ref19.error,
      helperText = _ref19.helperText,
      _ref19$showValidators = _ref19.showValidators,
      showValidators = _ref19$showValidators === void 0 ? false : _ref19$showValidators;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isValid = _useState6[0],
      setIsValid = _useState6[1];

  (0, _react.useEffect)(function () {
    setIsValid(Object.entries(Validations.code).every(function (_ref20) {
      var _ref21 = _slicedToArray(_ref20, 2),
          key = _ref21[0],
          regex = _ref21[1];

      return regex.test(value);
    }));
  }, [value]);
  (0, _react.useEffect)(function () {
    onValidChange(isValid);
  }, [isValid]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    required: true,
    InputLabelProps: {
      shrink: true
    },
    type: 'text',
    onChange: function onChange(_ref22) {
      var value = _ref22.target.value;
      return onValueChange(value);
    },
    label: 'Code',
    value: value,
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    helperText: error || helperText || "",
    variant: "outlined"
  }), showValidators && /*#__PURE__*/_react["default"].createElement(_List["default"], {
    dense: true
  }, Object.entries(Validations.code).map(function (_ref23, i) {
    var _ref24 = _slicedToArray(_ref23, 2),
        key = _ref24[0],
        regex = _ref24[1];

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, regex.test(value) ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
      style: {
        color: 'green'
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      style: {
        color: 'red'
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: key
    }));
  })));
};

exports.CodeField = CodeField;

var CustomField = function CustomField(_ref25) {
  var customField = _ref25.customField,
      value = _ref25.value,
      onValueChange = _ref25.onValueChange,
      onValidChange = _ref25.onValidChange,
      error = _ref25.error,
      _ref25$showValidators = _ref25.showValidators,
      showValidators = _ref25$showValidators === void 0 ? false : _ref25$showValidators;

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isValid = _useState8[0],
      setIsValid = _useState8[1];

  (0, _react.useEffect)(function () {
    !!customField.required ? setIsValid(!!value && Object.entries(customField.validations || []).every(function (_ref26) {
      var _ref27 = _slicedToArray(_ref26, 2),
          key = _ref27[0],
          regex = _ref27[1];

      return regex.test(value);
    })) : setIsValid(!value || !(value || "").replace(/\D/g, "") || Object.entries(customField.validations || []).every(function (_ref28) {
      var _ref29 = _slicedToArray(_ref28, 2),
          key = _ref29[0],
          regex = _ref29[1];

      return regex.test(value);
    }));
  }, [value]);
  (0, _react.useEffect)(function () {
    onValidChange(isValid);
  }, [isValid]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, customField.type === 'phone' ? /*#__PURE__*/_react["default"].createElement(PhoneField, {
    customField: customField,
    value: value,
    onValueChange: onValueChange,
    error: error,
    showValidators: showValidators,
    isValid: isValid
  }) : customField.type === 'date' ? /*#__PURE__*/_react["default"].createElement(DateField, {
    customField: customField,
    value: value,
    onValueChange: onValueChange,
    error: error,
    showValidators: showValidators,
    isValid: isValid
  }) : /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    InputLabelProps: {
      shrink: true
    },
    required: !!customField.required,
    type: customField.type || 'text',
    onChange: function onChange(_ref30) {
      var value = _ref30.target.value;
      return onValueChange(value);
    },
    label: customField.label,
    value: value || customField.initialValue || "",
    margin: "normal",
    fullWidth: true,
    error: !!error || !isValid && !!value,
    helperText: error || "",
    select: !!customField.options,
    autoComplete: "new-password",
    variant: "outlined"
  }, (customField.options || []).map(function (_ref31) {
    var label = _ref31.label,
        value = _ref31.value;
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: value,
      value: value
    }, label);
  })), showValidators && /*#__PURE__*/_react["default"].createElement(_List["default"], {
    dense: true
  }, Object.entries(customField.validations || []).map(function (_ref32, i) {
    var _ref33 = _slicedToArray(_ref32, 2),
        key = _ref33[0],
        regex = _ref33[1];

    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, regex.test(value) ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
      style: {
        color: 'green'
      }
    }) : /*#__PURE__*/_react["default"].createElement(_Close["default"], {
      style: {
        color: 'red'
      }
    })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: key
    }));
  })));
};

exports.CustomField = CustomField;